__turbopack_context__.v({
  "contentClassName": "e_3BJa_contentClassName",
  "heroClassName": "e_3BJa_heroClassName",
  "overlayShadow": "e_3BJa_overlayShadow",
});
